<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <el-button plain icon="el-icon-arrow-left" @click="backToMsg"></el-button>
        <div class="se-panel-title z-padding-left-5-precent ver-sub">全部消息</div>
      </div>
      <div class="panel-body">
        <div class="message-container">
          <div class="message-header">
            <h4>{{message.title}}</h4>
            <p>{{message.pub_time}}</p>
          </div>
          <div class="message-content">
            <p v-for="item in message.content.split('\r\n')">{{item}}</p>
          </div>
        </div>
        <div class="change-msg-container">
          <a v-if="message.msg_pre_id" href="javascript:;" class="prev-article" @click="Page(message.msg_pre_id)">上一篇</a>
          <span v-if="!message.msg_pre_id" class="z-color-muted">没有了</span>
          <a v-if="message.msg_next_id" href="javascript:;" @click="Page(message.msg_next_id)">下一篇</a>
          <span v-if="!message.msg_next_id" class="z-color-muted">没有了</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import userService from 'business/userService.js'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        listLoading:false,
        message:{
          content:''
        }
      }
    },
    components:{

    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.config()
    },
    watch:{
      '$route' () {
        this.config()
      },
      activeName(val){
        if(val === 'first'){
          this.MessageAllList()
        }
        if(val === 'second'){
          this.MessageUnReadList()
        }
        if(val === 'third'){
          this.MessageReadList()
        }
      },
    },
    methods:{
      ...mapActions(['MSG']),
      async config() {
        await this.Message()
        this.ResetMessage()
      },
      async Message() {
        this.listLoading = true
        let data = 'cmd=user_msg_show' +
          '&read_type=id' +
          '&id=' + this.$route.params.id
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.message = vueData.info
        }else{

        }
      },
      async ResetMessage() {
        let data = 'cmd=user_msg_list' +
          '&msg_type=0'
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.MSG({
            num:vueData.msg.allcount,
            list:vueData.msg.content
          })
        }else{

        }
      },
      async Page(id) {
        this.listLoading = true
        let data = 'cmd=user_msg_show' +
          '&read_type=id' +
          '&id=' + id
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.message = vueData.info
        }else{

        }
      },
      backToMsg() {
        this.$router.push('/message')
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
    margin-left: 80px;
  }

  .message-container {
    padding: 30px 35px;
    border: 1px solid #eee;
  }
  .message-header {
    text-align: center;
    border-bottom: 1px solid #eee;
  }
  .message-header h4 {
    font-weight: bold;
    font-size: 18px;
    color: #262829;
  }
  .message-header p {
    margin: 15px 0 20px;
    font-size: 14px;
    color: #a0a2a3;
  }
  .message-content {
    padding: 40px 0 120px;
  }
  .message-content p {
    line-height: 20px;
  }
  .change-msg-container {
    margin-top: 25px;
    font-size: 0;
    text-align: center;
  }
  .change-msg-container > a {
    display: inline-block;
    width: 94px;
    height: 32px;
    line-height: 30px;
    text-indent: 10px;
    border: 1px solid #d9d9d9;
    font-size: 12px;
    color: #262829;
    background: url(../../assets/imgs/right-icon.png) no-repeat 20px center;
  }
  .change-msg-container > a:first-child {
    margin-right: 25px;
    background: url(../../assets/imgs/left-icon.png) no-repeat 20px center;
  }
  .change-msg-container > span {
    font-size: 12px;
    color: #999;
  }
  .change-msg-container > span:first-child {
    margin-right: 25px;
  }
  .change-msg-container > a:hover {
    text-decoration: none;
  }
</style>




// WEBPACK FOOTER //
// src/pages/fuwu/content.vue